import * as React from 'react';
import MAccordion, {
  type AccordionProps as MAccordionProps,
} from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';

export type AccordionProps = Omit<MAccordionProps, 'children'> & {
  expandIcon?: React.ReactNode;
  title?: string;
  details: React.ReactNode;
  disableExpand?: boolean; // to disable the collapse function
};

export const Accordion: React.FunctionComponent<AccordionProps> = (
  props: AccordionProps,
) => {
  const theme = useTheme();
  const {
    expandIcon = (
      <ExpandMoreIcon style={{ color: theme.palette.primary.contrastText }} />
    ),
    title,
    details,
    defaultExpanded = true,
    disableExpand = false,
    ...others
  } = props;

  return (
    <MAccordion
      {...others}
      defaultExpanded={defaultExpanded || disableExpand}
      expanded={disableExpand ? true : undefined}
    >
      <AccordionSummary
        style={{
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          flexDirection: 'row-reverse',
        }}
        expandIcon={!disableExpand ? expandIcon : null}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        onClick={event => {
          disableExpand && event.stopPropagation();
        }}
      >
        <Typography
          sx={{
            flexShrink: 0,
            marginLeft: '0.75rem',
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
    </MAccordion>
  );
};
